import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { Toolbar, IconButton, Container, Badge, Grid, Typography, Box, Button, Card, CardContent, CardMedia } from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import StarIcon from '@mui/icons-material/Star';

export default function CustomerHome() {

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user'));

  if (user) {
    const role = user.role;
    console.log('Role:', role);

  } else {
    console.log('No user data found in session storage');
  }

  // Check if the user's role is "customer"
  if (!user || user.role !== "customer") {
    navigate('/not-authorized');
  }

  const [sellings, setSellings] = useState([]);
  const [civilID, setCivilID] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [devices, setDevices] = useState([]);
  const [eminumbers, setEminumbers] = useState();
  const [unsoldDevicesCount, setUnSoldDevicesCount] = useState(0);

  // Check if the user object exists and then access the email property
  if (user) {
    const email = user.email;
    console.log('Email:', email); // You can use the email as needed

  } else {
    console.log('No user data found in session storage');
  }



  useEffect(() => {
    fetchSellings();
    fetchDeviceDetails();
  }, []);

  const NavProfile = () => {
    navigate('/customerprofile');
  }

  const handleLogout = () => {
    // Remove user details from session storage
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    console.log('User details cleared from session storage');
    navigate('/');
  };

  const fetchSellings = async () => {
    try {
      const res = await axios.get(`https://app.smartco.live/api/customer/${user.email}`);

      // Log the response to check its structure
      console.log('Response data:', res.data);

      // Since res.data is an object, update the state accordingly
      setCustomers([res.data]);  // Store it in an array to maintain consistency if needed
      setCivilID([res.data.civil_id]);  // Set civil_id from the object
      const CIVILID = res.data.civil_id;

      console.log('Civil ID:', CIVILID);

      const response = await axios.get(`https://app.smartco.live/selling/getOneSelling/${CIVILID}`);
      setSellings(response.data);
      const emiNumbers = response.data.map(selling => selling.emiNumber);
      setEminumbers(emiNumbers);
      console.log(emiNumbers);
    } catch (error) {
      console.error('Error fetching devices:', error);
    }
  };

  const fetchDeviceDetails = async () => {
    try {
      const response = await axios.get('https://app.smartco.live/device/getDevice');
      setUnSoldDevicesCount(response.data.length); // Assuming each device represents a sold device
    } catch (error) {
      console.error('Error fetching device details:', error);
    }
  };


  return (
    <Container>
      <Toolbar
        sx={{
          pr: '24px',
          marginTop: '20px' // keep right padding when drawer closed
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <IconButton sx={{ marginRight: 'auto' }} onClick={NavProfile} >
            <Box
              sx={{
                background: 'linear-gradient(90deg, rgba(198, 61, 231, 0.2), rgba(117, 40, 136, 0.2))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
              }}
            >
              <AccountCircleOutlinedIcon
              />
            </Box>
          </IconButton>


          <Typography
            component="h1"
            variant="h6"
            noWrap
            sx={{
              flexGrow: 1,
              textAlign: 'center',
              background: 'linear-gradient(90deg, #C63DE7, #752888)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontFamily: 'Public Sans, sans-serif',
              fontWeight: 'bold'
            }}
          >
            SMARTCOO
          </Typography>

          <IconButton onClick={handleLogout} sx={{ marginLeft: 'auto' }}>
            <Box
              sx={{
                background: 'linear-gradient(90deg, rgba(198, 61, 231, 0.2), rgba(117, 40, 136, 0.2))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
              }}
            >
              <LogoutIcon />
            </Box>
          </IconButton>
        </Box>
      </Toolbar>

      <Box textAlign="center" mb={4}>
        <Box
          sx={{
            background: 'linear-gradient(135deg, #752888 0%, #C63DE7 100%)',
            marginTop: "20px",
            position: 'relative',
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(117, 40, 136, 0.3)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: '0 25px 70px rgba(117, 40, 136, 0.4)',
            }
          }}
        >
          {/* Decorative elements */}
          <Box
            sx={{
              position: 'absolute',
              top: -50,
              right: -50,
              width: 200,
              height: 200,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              filter: 'blur(40px)',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: -30,
              left: -30,
              width: 150,
              height: 150,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              filter: 'blur(30px)',
            }}
          />

          <Grid container spacing={4} alignItems="center" sx={{ p: { xs: 3, md: 5 }, position: 'relative', zIndex: 1 }}>
            <Grid item xs={12} md={7}>
              {/* Badge */}
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: 10,
                  px: 2,
                  py: 0.5,
                  mb: 2
                }}
              >
                <StarIcon sx={{ color: '#FFD700', fontSize: 18 }} />
                <Typography
                  variant="caption"
                  sx={{
                    color: 'white',
                    fontFamily: 'Public Sans, sans-serif',
                    fontWeight: 'bold',
                    letterSpacing: 1,
                    textTransform: 'uppercase'
                  }}
                >
                  New Collection
                </Typography>
              </Box>

              <Typography
                variant="h3"
                component="h2"
                gutterBottom
                sx={{
                  color: 'white',
                  fontFamily: 'Public Sans, sans-serif',
                  fontWeight: 'bold',
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  lineHeight: 1.2,
                  mb: 2
                }}
              >
                Discover Our Latest
                <br />
                <Box
                  component="span"
                  sx={{
                    background: 'linear-gradient(90deg, #FFD700, #FFA500)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  Showcase Devices
                </Box>
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontFamily: 'Public Sans, sans-serif',
                  mb: 3,
                  fontSize: { xs: '0.95rem', md: '1.1rem' },
                  lineHeight: 1.6,
                  maxWidth: 500,
                  mx: { xs: 'auto', md: 0 }
                }}
              >
                Experience the future of technology with our exclusive collection of premium devices.
                Handpicked for you!
              </Typography>

              <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'center', md: 'flex-start' }, flexWrap: 'wrap' }}>
                <Link to="/customerdevice" style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    endIcon={<ArrowForwardIcon />}
                    sx={{
                      backgroundColor: 'white',
                      color: '#752888',
                      px: 4,
                      py: 1.5,
                      fontSize: '1rem',
                      fontFamily: 'Public Sans, sans-serif',
                      fontWeight: 'bold',
                      borderRadius: 3,
                      textTransform: 'none',
                      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 12px 25px rgba(0, 0, 0, 0.3)',
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Explore Collection
                  </Button>
                </Link>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)',
                    px: 3,
                    py: 1.5,
                    borderRadius: 3,
                  }}
                >
                  <PhoneAndroidIcon />
                  <Typography
                    sx={{
                      fontFamily: 'Public Sans, sans-serif',
                      fontWeight: '600',
                      fontSize: '0.95rem'
                    }}
                  >
                    Latest Models Available
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  component="img"
                  src="../../../images/customerImage.png"
                  alt="Showcase Devices"
                  sx={{
                    width: '100%',
                    maxWidth: { xs: '250px', md: '300px' },
                    height: 'auto',
                    filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3))',
                    animation: 'float 3s ease-in-out infinite',
                    '@keyframes float': {
                      '0%, 100%': {
                        transform: 'translateY(0px)',
                      },
                      '50%': {
                        transform: 'translateY(-20px)',
                      },
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Typography variant="h5" gutterBottom>
        Your Devices
      </Typography>
      <Grid container spacing={3}>
        {sellings.map((selling) => (
          <Grid item xs={12} sm={6} md={4} key={selling._id}>
            <Link to={`/customerpurchase/${selling._id}`} style={{ textDecoration: 'none', color: "black" }}>
              <Card>
                <CardMedia
                  component="img"
                  height="140"
                  image={`${selling.imageName}`}
                  alt={selling.emiNumber}
                />
                <CardContent>
                  <Typography variant="h6" component="div">
                    {selling.deviceName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Purchase Date: {selling.date}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Device Price: {selling.price}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Advance: {selling.advance}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Remaining Balance: {selling.balance}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
